import { BookingItem, BookingSummary, BookingSummarySection } from '@/models/www/store/BookingSummary';
import { defineStore } from 'pinia';

export const useBookingSummaryStore = defineStore('bookingSummary', {
    state: () => {
        return {
            bookingSummary: {
                extras: [] as BookingItem[]
            } as BookingSummary,
            loading: false,
            displayTime: false
        }
    },
    getters: {
        getBookingSummary(): BookingSummary {
            return this.bookingSummary
        },
        getBookingSummarySections(): BookingSummarySection[] {
            return this.bookingSummary.bookingSections;
        },
        getLoading(): boolean {
            return this.loading;
        },
        getDisplayTime(): boolean {
            return this.displayTime;
        },
    },
    actions: {
        setBookingSummary(bookingSummary: BookingSummary) {
            this.bookingSummary = bookingSummary;
        },
        setLoading(value: boolean) {
            this.loading = value;
        },
        setDisplayTime(value: boolean) {
            this.displayTime = value;
        }
    }
})